import { defineMessages } from 'react-intl';
var msg = defineMessages({
    customer: {
        defaultMessage: 'Kundendaten',
        id: 'customerConfirm.menu.headline',
    },
});
export default msg;
